// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var inflightPromises = [];

var addInflightPromise = function addInflightPromise(resolver) {
  inflightPromises.push(resolver);
};

var resolveAndClearInflightPromises = function resolveAndClearInflightPromises() {
  while (inflightPromises.length) {
    var _inflightPromises$pop;

    (_inflightPromises$pop = inflightPromises.pop()) === null || _inflightPromises$pop === void 0 ? void 0 : _inflightPromises$pop();
  }
};

export { addInflightPromise, resolveAndClearInflightPromises };